import React from 'react';

import { CarouselElement } from '../../../element/carousel-element';
import type {
	CarouselElementType,
	ProjectHighlight,
	ProjectHighlightElementType,
	ProjectHighlightsData,
} from '../../../types';

interface ProjectHighlightsElementProps {
	data?: ProjectHighlightsData;
	isStreaming?: boolean;
	sectionKey?: string;
}

export const ProjectHighlightsElement = ({
	data,
	isStreaming = false,
	sectionKey,
}: ProjectHighlightsElementProps): React.JSX.Element | null => {
	if (!data) {
		return null;
	}

	try {
		const projectHighlightsData = data;
		const projectHighlightsCarouselChildren: ProjectHighlightElementType[] =
			projectHighlightsData.highlights.map((projectHighlight: ProjectHighlight) => ({
				tag: 'project-highlight-card',
				attributes: {
					title: projectHighlight.title,
					content: projectHighlight.content,
				},
			}));

		if (!projectHighlightsCarouselChildren.length) {
			return null;
		}

		const projectHighlightsCarouselComponent: CarouselElementType = {
			tag: 'carousel',
			children: projectHighlightsCarouselChildren,
		};

		return (
			<CarouselElement
				component={projectHighlightsCarouselComponent}
				position="two-rows-bottom"
				showArrows={false}
				isStreaming={isStreaming}
				sectionKey={sectionKey}
			/>
		);
	} catch {
		return null;
	}
};
